/* Keep gift removal scoped to one saved gift. Use an inline confirmation,
   never downgrade pending garments into a regular order. */
(() => {
  if (window.ptGiftingRemovalBound) return;
  window.ptGiftingRemovalBound = true;
  const root = window.Shopify?.routes?.root || '/';
  function protectCheckout(event) {
    const checkout = event.type === 'submit' || event.target.closest('.checkout-buttons a, [name="checkout"], .additional-checkout-buttons');
    const form = event.target.closest('cart-form');
    if (checkout && form?.querySelector('[data-gift-orphan]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      form.querySelector('[data-gift-orphan] [role="status"]')?.scrollIntoView({block:'center'});
    }
  }
  document.addEventListener('click', protectCheckout, true);
  document.addEventListener('submit', protectCheckout, true);
  document.addEventListener('click', event => {
    const remove = event.target.closest('.cart-item__remove');
    if (!remove || (!remove.dataset.giftId && !remove.hasAttribute('data-pt-confirm-remove'))) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const row = remove.closest('.cart-item');
    const form = remove.closest('cart-form');
    if (!form || form.cartUpdatePending) return;
    if (row.querySelector('[data-gift-remove-confirm]')) return;
    const panel = document.createElement('div');
    panel.dataset.giftRemoveConfirm = ''; panel.className = 'small-text lightly-spaced-row';
    panel.setAttribute('role', 'group'); panel.setAttribute('aria-label', 'Confirm removal');
    const message = document.createElement('p');
    const wholeGift = remove.hasAttribute('data-gifting-service-remove');
    message.textContent = wholeGift ? 'Remove this entire gift, including its pieces, gift packaging and saved card details?' : remove.dataset.giftId ? 'Remove this person and their linked Custom Size service? Removing the last person also removes this gift’s packaging and card.' : 'Remove this person and any linked Custom Size service?';
    const cancel = document.createElement('button'); cancel.type = 'button'; cancel.className = 'small-text underline'; cancel.textContent = 'Keep';
    const confirm = document.createElement('button'); confirm.type = 'button'; confirm.className = 'small-text underline'; confirm.textContent = wholeGift ? 'Remove gift' : 'Remove person';
    cancel.addEventListener('click', () => { panel.remove(); remove.focus(); });
    confirm.addEventListener('click', async () => {
      cancel.disabled = true; confirm.disabled = true;
      form.cartUpdatePending = true; form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(root + 'cart.js', {cache:'no-store'});
        if (!response.ok) throw new Error();
        const cart = await response.json();
        const key = new URL(remove.href).searchParams.get('id');
        const line = cart.items.find(item => item.key === key);
        if (!line) throw new Error('Your bag changed. Please refresh it before removing this item.');
        const gid = line.properties?._gift_id;
        const linked = line.properties?._customisation_id;
        let lines = cart.items.filter(item => item.key === key || (linked && item.properties?._customisation_id === linked && (!gid || item.properties?._gift_id === gid)));
        if (gid) {
          const remainingPeople = cart.items.filter(item => item.properties?._gift_id === gid && item.properties?._set_id && !lines.includes(item));
          if (wholeGift || !remainingPeople.length) lines = cart.items.filter(item => item.properties?._gift_id === gid);
        }
        const updates = Object.fromEntries(lines.map(item => [item.key,0]));
        const result = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
        if (!result.ok) throw new Error();
        const updated = await result.json();
        if (updated.items.some(item => updates[item.key] === 0)) throw new Error();
        await form.refresh();
        if (form.cartRefreshFailed) throw new Error('Your bag needs refreshing before checkout.');
        document.dispatchEvent(new CustomEvent('on:cart:change', {bubbles:true}));
      } catch (error) {
        message.textContent = error.message || 'We could not verify the removal. Refresh your bag before continuing.';
        form.cartRefreshFailed = true;
        form.cartUpdatePending = false; form.setAttribute('aria-busy','false');
      }
    });
    panel.append(message,cancel,document.createTextNode(' · '),confirm); remove.after(panel); cancel.focus();
  }, true);
})();
